import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'upsc-updatesuccess',
  templateUrl: './updatesuccess.component.html',
  styleUrls: ['./updatesuccess.component.scss']
})
export class UpdatesuccessComponent {
}
